<div class="overview-container">
    <div class="info-card">
        <div class="card-content">
            <div class="section">
                <div class="section-header">
                    <h3 class="section-title">Tenant Information</h3>
                    <button mat-stroked-button class="edit-tenant-button" matTooltip="Edit tenant settings"
                        (click)="openEditTenantDialog()"
                        [disabled]="tenantContextService.isLoading() || !tenantContextService.tenant()">
                        <mat-icon>edit</mat-icon>
                        Edit Tenant
                    </button>
                </div>
                <div class="info-grid">
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">id_card</mat-icon>
                            <span>Tenant Alias</span>
                        </div>
                        <div class="info-badge">
                            {{tenantContextService.tenant()?.tenantAlias}}
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">label</mat-icon>
                            <span>Tenant Name</span>
                        </div>
                        <div class="info-badge">
                            {{tenantContextService.tenant()?.tenantName}}
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">tag</mat-icon>
                            <span>Tenant ID</span>
                        </div>
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.tenantId}}
                            </div>
                            <button mat-icon-button class="copy-button" matTooltip="Copy Tenant ID"
                                (click)="copyToClipboard(tenantContextService.tenant()?.tenantId)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                            <span>Marketplace Subscription ID</span>
                        </div>
                        @if (tenantContextService.tenant()?.marketplaceSubscriptionId) {
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.marketplaceSubscriptionId}}
                            </div>
                            <button mat-icon-button class="copy-button" matTooltip="Copy Marketplace Subscription ID"
                                (click)="copyToClipboard(tenantContextService.tenant()?.marketplaceSubscriptionId)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        } @else {
                        <div class="info-badge">N/A</div>
                        }
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">location_on</mat-icon>
                            <span>Collect User Location</span>
                        </div>
                        @if (tenantContextService.tenant()?.collectUserLocation) {
                        <div class="info-badge status-badge">
                            <mat-icon class="material-symbols-outlined status-icon enabled">check_circle</mat-icon>
                            <span class="status-text enabled">Enabled</span>
                        </div>
                        } @else {
                        <div class="info-badge status-badge">
                            <mat-icon class="material-symbols-outlined status-icon disabled">cancel</mat-icon>
                            <span class="status-text disabled">Disabled</span>
                        </div>
                        }
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">bolt</mat-icon>
                            <span>Tenant Status</span>
                        </div>
                        @if (tenantContextService.tenant()?.isEnabled) {
                        <div class="info-badge status-badge">
                            <mat-icon class="material-symbols-outlined status-icon enabled">check_circle</mat-icon>
                            <span class="status-text enabled">Enabled</span>
                        </div>
                        } @else {
                        <div class="info-badge status-badge">
                            <mat-icon class="material-symbols-outlined status-icon disabled">cancel</mat-icon>
                            <span class="status-text disabled">Disabled</span>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <mat-divider class="section-divider"></mat-divider>

            <div class="section">
                <div class="section-header">
                    <h3 class="section-title">Owner Information</h3>
                </div>
                <div class="info-grid">
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">person</mat-icon>
                            <span>Name</span>
                        </div>
                        <div class="info-badge">
                            @if (tenantContextService.tenant()?.ownerUserAccount?.givenName ||
                            tenantContextService.tenant()?.ownerUserAccount?.surname) {
                            {{(tenantContextService.tenant()?.ownerUserAccount?.givenName || '') + ' ' +
                            (tenantContextService.tenant()?.ownerUserAccount?.surname || '')}}
                            } @else {
                            N/A
                            }
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">email</mat-icon>
                            <span>Email</span>
                        </div>
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail || 'N/A'}}
                            </div>
                            @if (tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail) {
                            <button mat-icon-button class="copy-button" matTooltip="Copy Email"
                                (click)="copyToClipboard(tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            }
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">tag</mat-icon>
                            <span>User ID</span>
                        </div>
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.ownerUserAccount?.userAccountId || 'N/A'}}
                            </div>
                            @if (tenantContextService.tenant()?.ownerUserAccount?.userAccountId) {
                            <button mat-icon-button class="copy-button" matTooltip="Copy User ID"
                                (click)="copyToClipboard(tenantContextService.tenant()?.ownerUserAccount?.userAccountId)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            }
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">email</mat-icon>
                            <span>AAD Email</span>
                        </div>
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail || 'N/A'}}
                            </div>
                            @if (tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail) {
                            <button mat-icon-button class="copy-button" matTooltip="Copy AAD Email"
                                (click)="copyToClipboard(tenantContextService.tenant()?.ownerUserAccount?.aadUserEmail)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            }
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">tag</mat-icon>
                            <span>AAD User ID</span>
                        </div>
                        <div class="info-badge-container">
                            <div class="info-badge">
                                {{tenantContextService.tenant()?.ownerUserAccount?.aadUserId || 'N/A'}}
                            </div>
                            @if (tenantContextService.tenant()?.ownerUserAccount?.aadUserId) {
                            <button mat-icon-button class="copy-button" matTooltip="Copy AAD User ID"
                                (click)="copyToClipboard(tenantContextService.tenant()?.ownerUserAccount?.aadUserId)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            }
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">
                            <mat-icon class="material-symbols-outlined">cloud_lock</mat-icon>
                            <span>SSO Status</span>
                        </div>
                        <div class="info-badge-container">
                            @if (tenantContextService.tenant()?.ownerUserAccount?.isSsoUser) {
                            <div class="info-badge status-badge">
                                <mat-icon class="material-symbols-outlined status-icon enabled">check_circle</mat-icon>
                                <span class="status-text enabled">Enabled</span>
                            </div>
                            } @else {
                            <div class="info-badge status-badge">
                                <mat-icon class="material-symbols-outlined status-icon disabled">cancel</mat-icon>
                                <span class="status-text disabled">Disabled</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <mat-divider class="section-divider"></mat-divider>

                <div class="section">
                    <div class="section-header">
                        <h3 class="section-title">Feature Configuration</h3>
                        <span class="feature-counter">{{getEnabledFeaturesCount()}} of {{getTotalFeaturesCount()}}
                            enabled</span>
                    </div>
                    <div class="features-grid">
                        <div class="feature-card">
                            <div class="feature-icon">
                                <mat-icon class="material-symbols-outlined">dashboard</mat-icon>
                            </div>
                            <div class="feature-info">
                                <h3>Dashboards</h3>
                                <p class="feature-description">Analytics dashboards and data visualisation tools
                                </p>
                                @if (tenantContextService.tenant()?.hasDashboardsAccess) {
                                <span class="feature-status enabled">
                                    <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                                    Enabled
                                </span>
                                } @else {
                                <span class="feature-status disabled">
                                    <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                                    Disabled
                                </span>
                                }
                            </div>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <mat-icon class="material-symbols-outlined">slideshow</mat-icon>
                            </div>
                            <div class="feature-info">
                                <h3>Presentations</h3>
                                <p class="feature-description">Presentation creation and sharing capabilities</p>
                                @if (tenantContextService.tenant()?.hasPresentationsAccess) {
                                <span class="feature-status enabled">
                                    <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                                    Enabled
                                </span>
                                } @else {
                                <span class="feature-status disabled">
                                    <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                                    Disabled
                                </span>
                                }
                            </div>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <mat-icon class="material-symbols-outlined">network_intelligence</mat-icon>
                            </div>
                            <div class="feature-info">
                                <h3>Cognition</h3>
                                <p class="feature-description">AI-powered insights using custom agentic services
                                </p>
                                @if (tenantContextService.tenant()?.hasCognitionAccess) {
                                <span class="feature-status enabled">
                                    <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                                    Enabled
                                </span>
                                } @else {
                                <span class="feature-status disabled">
                                    <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                                    Disabled
                                </span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>